import BaseStatefulController from '../baseStatefulController';

export default class BaseSystemController extends BaseStatefulController {
  get elementsIdPrefix() {
    return 'system_ui'
  }
}
